import { loc } from "@/_services/localization"
import { handleAccessibleOnKeyDown } from "@/_services/utils"
import React from "react"

class PaginationLoadMore extends React.Component {
  render() {
    const {
      pageNumber,
      pageSize,
      loading,
      paginationParams,
      rowsCount,
      useHorizontalMargins,
      getEntities,
      hasMoreThanOnePage,
      typeFieldBreakdownValue,
    } = this.props
    const pageLowerBound = (pageNumber - 1) * pageSize + 1
    let pageUpperBound = pageNumber * pageSize
    pageUpperBound = pageUpperBound < rowsCount ? pageUpperBound : rowsCount

    return (
      <div
        className={
          "inline-flex flex-dir-column justify-content-center font-1 text-black-lightest" +
          (hasMoreThanOnePage ? "" : " text-center") +
          (useHorizontalMargins ? " ml-theme mr-theme" : "")
        }
      >
        {pageLowerBound !== undefined && pageUpperBound !== undefined && rowsCount !== undefined && (
          <div>
            {pageLowerBound}-{pageUpperBound}
            {paginationParams ? `/${paginationParams.continues ? `* (${rowsCount})` : rowsCount} ` : " "}
            {loc(rowsCount > 1 ? "rows" : "row")}
          </div>
        )}

        {paginationParams?.continues && (
          <div
            tabIndex="0"
            className={"link flex align-items-center " + (loading ? "text-black-lightest pointer-events-none" : "")}
            onKeyDown={event => {
              handleAccessibleOnKeyDown({
                event,
                fn: () => getEntities && getEntities({ nextPagination: paginationParams, typeFieldBreakdownValue }),
              })
            }}
            onClick={() => getEntities && getEntities({ nextPagination: paginationParams, typeFieldBreakdownValue })}
          >
            <i className={"icn-xxs " + (loading ? "icn-circle-notch icn-spin" : "icn-plus-light")} />
            {loc("Load more")}
          </div>
        )}
      </div>
    )
  }
}

export default PaginationLoadMore
